import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-exports",
  "use": "icon-exports-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-exports\"><path d=\"M725.312 608.768V433.152c0-74.112-326.784 24.192-384 263.424 0 0-75.584 88-85.312 0 0 0 109.696-482.944 469.312-482.944V81.92s42.688-61.824 128 43.968L1024 301.44l-298.688 307.328zM128 433.152a43.392 43.392 0 0 0-42.688 43.968v351.232c0 24.256 19.072 43.904 42.688 43.904h725.312a43.328 43.328 0 0 0 42.688-43.904v-43.904c0-24.256 19.072-43.968 42.688-43.968 23.616 0 42.688 19.712 42.688 43.968v87.808C981.312 920.768 943.104 960 896 960H85.312C38.208 960 0 920.768 0 872.256V433.152c0-48.512 38.208-87.808 85.312-87.808H128c23.552 0 42.688 19.648 42.688 43.904A43.328 43.328 0 0 1 128 433.152z\" fill=\"\" p-id=\"18999\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/exports.svg
// module id = kg1X
// module chunks = 42